import { useEffect } from 'react';
import { Modal, Button } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useQueryClient } from '@tanstack/react-query';


//  style
import helperStyle from '../../styles/helperModals.module.scss';
//  icons
import { FaTrashRestoreAlt } from 'react-icons/fa';
//  redux actions
import { resetHelperModals, changeSuccessOperation, changeSuccessText } from "../../redux/slices/helperModalsSlice";
//  api
import { api } from '../../api';




const AskToDeleteItem = () => {
  //  variables
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const deletingData = useSelector((state) => state.helperModals);


  //  handlers
  const handleDeleteItem = async () => {
    dispatch(resetHelperModals()); // delete id, name, url and turn false to invisble modal
    try {
      const deleteResult = await api.delete(deletingData.deletingItemUrl);

      if (deleteResult.status === 204) {
        queryClient.refetchQueries(deletingData.refetchKey);
        dispatch(changeSuccessText("محصول با موفقیت حذف شد"));
        dispatch(changeSuccessOperation());
      }
    }
    catch (error) {
      console.log("error in delete item : ", error);
    }
  };



  return (
    <Modal
      visible={deletingData.askToDelete}
      footer={null}
      closable={false}
      className="modalHasRadius modalHasRedBorder"
    >
      <div className={helperStyle.askToDeleteContainer}>
        <FaTrashRestoreAlt className={helperStyle.deleteIcon} />
        <h1 className={helperStyle.deleteText}>آیا از حذف این {deletingData.itemName} اطمینان دارید؟</h1>
        <div className={helperStyle.deleteButtons}>
          <Button
            size="large"
            className="px-10 buttonHasRadius dangerButton"
            onClick={handleDeleteItem}
          >
            حذف
          </Button>

          <Button
            size="large"
            className="px-10 buttonHasRadius"
            type="primary"
            onClick={() => dispatch(resetHelperModals())}
          >
            بیخیال
          </Button>

        </div>
      </div>
    </Modal>
  );
};

export default AskToDeleteItem;